<template>
</template>
<script>
export default {
  name: 'Birthday'
}
</script>